import {ThresholdType} from './models/threshold-type.enum';

export const thresholdTypes = new Map<string, ThresholdType>([
  ['cases', ThresholdType.CASES],
  ['lbs', ThresholdType.LBS],
]);
